const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Track Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Tracks} Tracks the resource defined to manage Tracks
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 */
app.directive('journeyHost', ['AccessHelper', 'Application', 'Authorization', 'Journeys', 'UserJourneys', 'Users', '$translate', function(AccessHelper, Application, Authorization, Journeys, UserJourneys, Users, $translate) {
    return {
      restrict: 'E',
      scope: {
        fullData: '='
      },
      template: require('../../templates/directives/journey-host.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.userNames = {};
          self.translations = {};
          self.engage = Authorization.getAuthToken().company && Authorization.getAuthToken().company.engage;
          var routeParameters = Application.navigation.getRouteParameters();
          self.id = routeParameters.id;
          var dropoffDate = moment().subtract(30, 'days');
          self.circleStats = {
            totalParticipants: 0,
            completedParticipants: 0,
            activeParticipants: 0,
            averageDuration: '--'
          };

          self.allowEdit = function() {
            return AccessHelper.isAllowed(['admin', 'journeys', 'edit'], null, ['admin', 'creator']);
          }

          self.getProgress = function(userJourney) {
            const satisfied = userJourney.satisfiable_entities.reduce((numberSatisfied, sE) => {
              if (sE.satisfied_status) {
                numberSatisfied++
              }
              return numberSatisfied;
            }, 0);
            
            let percentCompleted = 0;
            if (userJourney.satisfiable_entities.length > 0) {
              percentCompleted = ((satisfied / self.journey.satisfiable_entities.length) * 100).toFixed(0);
            }
            return (percentCompleted).toString() + '%';
          };

          self.getProgressStyle = function(userJourney) {
            const progress = self.getProgress(userJourney);
            return {width: progress};
          }

          self.editMenu = {
            visible: false,
            activeId: null,
            closeHandler: function(){
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            },
            clickHandler: function(i){
              if (self.editMenu.visible) {
                if (self.editMenu.activeId === i) {
                  self.editMenu.visible = false;
                  self.editMenu.activeId = null;
                } else {
                  self.editMenu.activeId = i;
                }
              } else {
                self.editMenu.activeId = i;
                self.editMenu.visible = true;
              }
            }
          };

          self.predicate = {
            current: 'user.full_name',
            past: 'user.full_name',
            assigned: 'assignee.full_name'
          };

          self.reverse = {
            current: false,
            past: false,
            assigned: false
          };

          self.smart_filter = {};
          self.selectionDirectory = {};
          self.selections = {
            select: function(item) {
              var id = item._id;
              if (self.selectionDirectory[id]) {
                delete self.selectionDirectory[id];
              } else {
                self.selectionDirectory[id] = item;
              }
              // self.searchItems.csv_selected = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;
              var ids = [];
              for (var id in self.selectionDirectory) {
                ids.push(self.selectionDirectory[id]._id.toString());
              }
              self.searchItems.csv_selected += '&users=$in,' + ids.length + ',' + ids.join(',');
            },
            isChecked: function(item) {
              if (!item || !item._id) {
                return false;
              }
              return self.selectionDirectory[item._id] ? true : false;
            },
            clear: function() {
              self.selectionDirectory = {};
            }
          };

          const createFilter = function(query_arguments) {
            // TODO: Adjust for journeys CSV
            self.smart_filter = {};
            self.searching = false;
            if (!query_arguments || (typeof query_arguments === 'object' && Object.keys(query_arguments).length === 0)) {
              self.searching = true;
              return;
            }
            if (query_arguments && typeof query_arguments === 'object' && Object.keys(query_arguments).length) {
              self.searching = true;
            }
            self.searchItems.csv_filtered = Application.API + '/learn/v3/journeys/' + self.id + '/csv?authtoken=' + Authorization.getAuthToken().authtoken;
            // self.searchItems.csv_selected = Application.API + '/learn/v3/tracks/csv/' + self.track._id + '?authtoken=' + Authorization.getAuthToken().authtoken;

            for (var key in query_arguments) {
              self.smart_filter[key] = query_arguments[key];
              self.searchItems.csv_filtered += '&' + key + '=' + encodeURIComponent(query_arguments[key]);
              // self.searchItems.csv_selected += '&' + key + '=' + encodeURIComponent(query_arguments[key]);
            }
          };

          self.searchItems = {
            placeholder: self.translations['trackHost.search_placeholder'],
            onQueryParticipants: function() {
              self.paginate.pageData.page = 0;
              self.getParticipants();
            },
            onQuery: function(query_arguments) {
              createFilter(query_arguments);
              self.searchItems.onQueryParticipants();
            },
            csv_filtered: Application.API + '/learn/v3/journeys/' + self.id + '/csv?authtoken=' + Authorization.getAuthToken().authtoken,
            // csv_selected: Application.API + '/learn/v3/tracks/csv/' + Application.navigation.getRouteParameters().id + '?authtoken=' + Authorization.getAuthToken().authtoken
          };

          self.sortAction = function(type, location) {
            if (self.predicate[location] === type) {
              self.reverse[location] = !self.reverse[location];
              return;
            }
            self.reverse[location] = false;
            self.predicate[location] = type;
          };

          self.usertoken = Authorization.getAuthToken();

          self.isAdmin = function() {
            if (self.usertoken.user.role === 'admin') {
              return true;
            } else {
              return false;
            }
          };

          self.sortParam = function(items, parameter, order) {
            order = order === undefined ? 1 : order;

            items.sort(function(a, b) {
              if (a[parameter] < b[parameter]) {
                return (-1 * order);
              }
              if (a[parameter] > b[parameter]) {
                return (1 * order);
              }
              return 0;
            });

            return items;
          };

          self.goToUser = function(user) {
            if (!user || !user._id) {
              return;
            }
            Application.navigation.goTo('/edit/users/' + user._id);
          };

          self.resolveUsers = function() {
            var length = 0;
            var users = null;
            angular.forEach(self.modifications, function(mod) {
              var user = mod.user;
              if (!self.userNames[user]) {
                length++;
                if (!users) {
                  users = '' + user;
                  return;
                }
                users += ',' + user;
              }
            });
            return Users.find({
              fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
              _id: '$in,' + length + ',' + users
            }).$promise.then(function(users) {
              angular.forEach(users, function(user) {
                self.userNames[user._id] = user;
              });
              self.modLoading = false;
            });
          };

          self.parseUserJourneys = function(userJourneys) {
        
            self.totalCourses = self.journey.satisfiable_entities.length;

            for (var i = 0; i < userJourneys.length; i++) {

              // Add progress bar data to user track
              var completedItems = userJourneys[i].satisfiable_entities.filter(entity => entity.satisfied_status);
              userJourneys[i].progress = ~~(completedItems / self.totalCourses * 100);

              // Add duration data to user track
              var started = moment(new Date(userJourneys[i].createdAt));
              var last = userJourneys[i].satisfied_status ? moment(new Date(userJourneys[i].satisfied_date)) : moment();
              userJourneys[i].duration = Math.max(0, last.diff(started, 'days')) + ' days';
      
              // Add "hasCompleted" data to user journey
              if (userJourneys[i].satisfied_status) {
                userJourneys[i].active = false;
                self.hasCompleted = true;
              }
            }
          };

          
          // Build search filtering


          const getIdList = (filter) => {
            const idList = filter.split(",").filter(string => string.length >= 23);
            return {'$in': idList};
          }

          self.privacyFilter = () => {
            let filtered_query = {};
            if (self.smart_filter.privacy_locations && self.smart_filter.privacy_locations.length > 0) {
              filtered_query.linked_locations = getIdList(self.smart_filter.privacy_locations);
            }
            if (self.smart_filter.privacy_departments && self.smart_filter.privacy_departments.length > 0) {
              filtered_query.linked_departments = getIdList(self.smart_filter.privacy_departments);
            }
            if (self.smart_filter.privacy_teams) {
              filtered_query.linked_teams = getIdList(self.smart_filter.privacy_teams);
            }
            if (self.smart_filter.privacy_org_levels && self.smart_filter.privacy_org_levels.length > 0) {
              filtered_query.linked_org_level = getIdList(self.smart_filter.privacy_org_levels);
            }
            if (self.smart_filter.privacy_grades && self.smart_filter.privacy_grades.length > 0) {
              filtered_query.linked_grade = getIdList(self.smart_filter.privacy_grades);
            }
            if (self.smart_filter['$or']) {
              const namesearch_arguments = self.smart_filter['$or'].split(',');
              if (namesearch_arguments[4]) {
                if (Object.keys(filtered_query).length) {
                  const queries = {'$or': [filtered_query, {full_name: {'$regex': namesearch_arguments[4], '$options': 'i'}, email: {'$regex': namesearch_arguments[4], '$options': 'i'}}]};
                  return queries;
                } 
                filtered_query.full_name = {'$regex': namesearch_arguments[4], '$options': 'i'};
                filtered_query.email = {'$regex': namesearch_arguments[4], '$options': 'i'}
              }
            }
            return filtered_query;
          }

          // Request Participants
          // TODO: Update with user journey schema and endpoints, Refactor to async with new endpoint

          self.getParticipants = async function() {
            const filter = self.privacyFilter();
            try {
              const data = await UserJourneys.list({
                query: {userFilter: filter, journey: routeParameters.id},
                page: self.paginate.pageData.page,
                perPage: self.paginate.pageData.perPage
              }).$promise;
              self.userJourneys = data;
              self.paginate.pageData.pageContents = self.userJourneys; 
              self.paginate.checkPaging(self.paginate.pageData);
              self.parseUserJourneys(self.paginate.pageData.pageContents);
              self.loadingUserTracks = false;
            } catch (error) {
              console.log('Error occured getting journeys ', routeParameters.id, error);
              Application.notifications.setError(self.translations['trackHost.unable_to_get_track']);
            }
            $scope.$apply();
          };


          // Pagination

          self.paginate = {
            pageData: {
              page: 0, 
              perPage: 20,
              noNext: true,
              pageContents: []
            },
            next: function(participantPageObject, participantFunction) {
              participantPageObject.page++;
              participantFunction();
            },
            previous: function(participantPageObject, participantFunction) {
              participantPageObject.page--;
              participantFunction();
            },
            checkPaging: function(participantPageObject) {
              if (participantPageObject.pageContents.length < participantPageObject.perPage) {
                participantPageObject.noNext = true;
                return;
              }
              if (participantPageObject.numberOfPages - 1 === participantPageObject.page) {
                participantPageObject.noNext = true;
                return;
              }
              if (participantPageObject.pageContents.length === participantPageObject.perPage) {
                participantPageObject.noNext = false;
              }
            }
          }

          self.initialize = async function() {
            self.loadingJourney = true;
            self.loadingUserJourneys = true;
            self.modLoading = true;
            if (!routeParameters.id) {
              console.log('No id specified');
              Application.navigation.goToHome();
              return;
            }

            try {
              const journey = await Journeys.get({subresource: routeParameters.id}).$promise;
              if (journey.company !== Authorization.getAuthToken().company._id) {
                self.noEdit = true;
              }
              self.journey = journey;
              self.csvDownload = Application.API + '/learn/v3/journeys/csv/' + self.id + '?authtoken=' + Authorization.getAuthToken().authtoken;
              self.allowRating = self.journey && self.journey.rating_configuration && self.journey.rating_configuration.allow_rating;
              if (self.journey.average_rating) {
                var outOfFive = Math.round(self.journey.average_rating * 5) / 100;
                if (outOfFive) {
                  self.rating = outOfFive;
                }
              }
              self.loadingJourney = false;
            } catch (e) {
              console.log('Error occured getting journey ', routeParameters.id, e);
              Application.notifications.setError(self.translations['trackHost.unable_to_get_track']);
            }

            await self.getParticipants().$promise;

            $scope.$apply();
          };

          self.initialize();

          $translate([
            'trackHost.search_placeholder',
            'trackHost.unable_to_get_track',
            'trackHost.unable_to_get_track',
            'trackHost.open_assignments',
            'trackHost.total_participants',
            'trackHost.all_time',
            'trackHost.num_completed',
            'trackHost.num_still_completing',
            'trackHost.average_days_to_complete'
          ]).then(function (translations) {
            self.translations = translations;
          })
        }],
      controllerAs: 'host'
    };
  }]);
